<template>
  <div class="tenants-show-view">
    <loader v-if="isLoading" />

    <div v-if="isSuccessfullyLoaded">
      <h1>{{tenant.name}}</h1>

      <template v-if="isAuthenticatedAsAdmin">
        <link-button
          :to="{ name: 'edit-tenant', params: { id: tenant.id } }"
          icon="pencil"
        >{{$t('actions.edit')}}</link-button>

        <h3>{{$t('headlines.providers')}}</h3>
        <tenant-provider-manager :tenant="tenant" />
      </template>

      <h3>{{$t('headlines.tokens')}}</h3>
      <auth-token-manager :resource="tenant" @update="updateAuthTokens" />

      <template v-if="tenant.colors.length">
        <h3>{{$t('headlines.colorPalette')}}</h3>
        <color-table :colors="tenant.colors" />
      </template>
    </div>
  </div>
</template>

<script>
import AuthTokenManager from '@/components/AuthTokenManager';
import ColorTable from '@/components/ColorTable';
import LinkButton from '@/components/LinkButton';
import tenantQuery from '@/api/queries/tenant.graphql';
import Loader from '@/components/Loader';
import TenantProviderManager from '@/components/TenantProviderManager';
import View from '@/mixins/View';

export default {
  name: 'tenants-show-view',
  mixins: [
    View,
  ],
  components: {
    AuthTokenManager,
    ColorTable,
    LinkButton,
    Loader,
    TenantProviderManager,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'show',
          text: () => this.tenant.name,
          route: { name: 'tenant', params: { id: this.id } },
          isLoading: !this.isSuccessfullyLoaded,
        },
      ];
    },
    id() {
      return this.$route.params.id;
    },
    isSuccessfullyLoaded() {
      return this.isLoaded && this.tenant;
    },
  },
  methods: {
    updateAuthTokens(tokens) {
      this.tenant.authTokens = tokens;
    },
  },
  apollo: {
    tenant: {
      query: tenantQuery,
      variables() {
        return { id: this.id };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      update({ tenant }) {
        return tenant;
      },
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  i18n: {
    messages: {
      de: {
        headlines: {
          colorPalette: 'Farbpalette',
          providers: 'Provider',
          tokens: 'Zugangsschlüssel',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ShowView.vue?2d1f17c2